import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import Home from './pages/Home';
import Process from './pages/Process';
import Rights from './pages/Rights';
import Support from './pages/Support';
import Journal from './pages/Journal';
import Trauma from './pages/Trauma';
import Grounding from './pages/Grounding';
import HelpNow from './pages/HelpNow';
import DomesticAbuse from './pages/DomesticAbuse';
import Stats from './pages/Stats';
import GuidedJournal from './pages/GuidedJournal';
import FAQ from './pages/FAQ';
import SexualViolence from './pages/SexualViolence';
import About from './pages/About';
import Why from './pages/Why';
import Accessibility from './pages/Accessibility';
import Compliance from './pages/Compliance';
import Consent from './pages/Consent';
import Crossed from './pages/Crossed';
import { LanguageProvider } from './i18n/LanguageContext';
import { NationProvider } from './i18n/NationContext';
import useAnonymousTracker from './hooks/useAnonymousTracker';

function NotFound() {
  return (
    <div className="max-w-xl mx-auto px-6 py-20 text-center">
      <h1 className="font-heading" style={{ fontSize: 30, color: 'var(--tf-text)' }}>
        Page not found
      </h1>
      <p className="font-body mt-3" style={{ color: 'var(--tf-text-secondary)' }}>
        The page you were looking for doesn&apos;t exist.
      </p>
      <a href="/" className="tf-link mt-6 inline-block" data-testid="notfound-home">
        ← Back to home
      </a>
    </div>
  );
}

function ScrollAndTrack() {
  // Track every route change for anonymous totals + scroll to top.
  const { pathname } = useLocation();
  useAnonymousTracker();
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <NationProvider>
          <BrowserRouter>
          <ScrollAndTrack />
          <Routes>
          <Route path="/" element={<Landing />} />
          <Route
            path="/app"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path="/app/sexual-violence"
            element={
              <Layout>
                <SexualViolence />
              </Layout>
            }
          />
          <Route
            path="/app/process"
            element={
              <Layout>
                <Process />
              </Layout>
            }
          />
          <Route
            path="/app/rights"
            element={
              <Layout>
                <Rights />
              </Layout>
            }
          />
          <Route
            path="/app/domestic-abuse"
            element={
              <Layout>
                <DomesticAbuse />
              </Layout>
            }
          />
          <Route
            path="/app/support"
            element={
              <Layout>
                <Support />
              </Layout>
            }
          />
          <Route
            path="/app/journal"
            element={
              <Layout>
                <Journal />
              </Layout>
            }
          />
          <Route
            path="/app/trauma"
            element={
              <Layout>
                <Trauma />
              </Layout>
            }
          />
          <Route
            path="/app/grounding"
            element={
              <Layout>
                <Grounding />
              </Layout>
            }
          />
          <Route
            path="/app/help-now"
            element={
              <Layout>
                <HelpNow />
              </Layout>
            }
          />
          <Route
            path="/app/guided-journal"
            element={
              <Layout>
                <GuidedJournal />
              </Layout>
            }
          />
          <Route
            path="/app/faq"
            element={
              <Layout>
                <FAQ />
              </Layout>
            }
          />
          <Route
            path="/app/stats"
            element={
              <Layout>
                <Stats />
              </Layout>
            }
          />
          <Route
            path="/app/about"
            element={
              <Layout>
                <About />
              </Layout>
            }
          />
          <Route
            path="/app/why"
            element={
              <Layout>
                <Why />
              </Layout>
            }
          />
          <Route
            path="/app/accessibility"
            element={
              <Layout>
                <Accessibility />
              </Layout>
            }
          />
          <Route
            path="/app/compliance"
            element={
              <Layout>
                <Compliance />
              </Layout>
            }
          />
          <Route
            path="/app/consent"
            element={
              <Layout>
                <Consent />
              </Layout>
            }
          />
          <Route
            path="/app/crossed-the-line"
            element={
              <Layout>
                <Crossed />
              </Layout>
            }
          />
          <Route path="/help-now" element={<Navigate to="/app/help-now" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      </NationProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
